<template>
  <el-dialog
    :title="title"
    :visible="isShow"
    width="700px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    @close="closeDialog"
  >
    <div class="sel-config" v-loading="loading">
      <div class="mt20">
        <el-form
          ref="acForm"
          size="small"
          label-width="120px"
          :model="form"
          :rules="rules"
        >
          <el-form-item label="答题卡名称：" prop="acCardNameNew">
            <el-input
              style="width: 450px"
              v-model="form.acCardNameNew"
              placeholder="请输入答题卡名称"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="学科：" prop="acKmCode">
            <el-select
              style="width: 450px"
              v-model="form.acKmCode"
              placeholder="选择科目"
              clearable
            >
              <el-option
                v-for="item in subjectList"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年级：" prop="acPeriod">
            <el-select
              style="width: 450px"
              v-model="form.acPeriod"
              placeholder="请选择年级"
            >
              <el-option
                v-for="item in gradeList"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="考试类型：">
            <el-select
              style="width: 450px"
              v-model="form.acksType"
              placeholder="选择考试类型"
              clearable
            >
              <el-option
                v-for="item in exmTypes"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button
        type="primary"
        @click="handleSaveCard('acForm')"
        :loading="saveLoading"
        >确 定</el-button
      >
    </span>
    <!-- <div class="ac-list">
        <el-row>
          <el-col :span="5" :offset="1">
            <el-card shadow="hover">
              <div class="card" @click="addAcCard">
                <i class="el-icon-plus"></i>
                <p>新建空白答题卡</p>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div> -->
  </el-dialog>
  <!-- <ModalCardEmpty
      :open="dialogVisibleEmpty"
      @onChange="handleEmptyDialogChange"
      @saveCard="handleSaveCard"
    /> -->
</template>

<script>
import AcCardApi from "@/services/acCard";
import ModalCardEmpty from "./home/modal-card-empty";
import { mapGetters, mapMutations, mapState } from "vuex";
export default {
  name: "AcDialog",
  components: {
    ModalCardEmpty,
  },
  props: {},
  computed: {
    ...mapGetters({
      kMAndPeriod: "card/kMAndPeriod",
      answerSheet: "answerPanel/answerSheet",
    }),
    // ...mapState("card", {
    //   kMAndPeriod: (state) => state.kMAndPeriod, //学科和学段的字典
    // }),
  },
  watch: {},
  data() {
    return {
      isShow: false,
      title: "新建答题卡",
      subjectList: [], //所有学学科列表

      gradeList: [], //所有年级列表,
      exmTypes: [],

      mBIndex: -1,
      layerList: [],
      loading: false,
      debounceTimer: undefined,
      dialogVisibleEmpty: false,
      modalTemplateSettingParams: {},

      saveLoading: false,
      rules: {
        acCardNameNew: [
          { required: true, message: "请输入答题卡名称", trigger: "blur" },
        ],
        acKmCode: [{ required: true, message: "请选择学科", trigger: "change" }],
        acPeriod: [{ required: true, message: "请选择年级", trigger: "change" }],
      },
      form: {},
    };
  },
  created() {},
  mounted() {

  },
  methods: {
    extractTextFromHtml(htmlString) {
      var tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlString;
      return tempDiv.textContent || tempDiv.innerText || "";
    },
    extractHtmlFromText(newText,originHtmlString) {
      return originHtmlString.replaceAll(this.extractTextFromHtml(originHtmlString),newText)
    },
    // 获取学科和 学段
    getKMAndPeriod() {
      let km = this.kMAndPeriod.km;
      let period = this.kMAndPeriod.period;
      let exmType = this.kMAndPeriod.ksType;

      this.subjectList = km ? [...km] : [];

      this.gradeList = period ? [...period] : [];

      this.exmTypes = exmType ? [...exmType] : [];
    },
    handlerOpen(guid) {
      if (guid) {
        this.title = "编辑答题卡";
      }
      this.form = { ...this.answerSheet };
      //TODO: 答题卡名称不做处理
      this.form.acCardNameNew = this.extractTextFromHtml(this.answerSheet.acCardNameHtml)
      
      console.log('this.answerSheet.acCardName====>', this.form.acCardNameNew);
      this.form = {...this.form}
      
      this.getKMAndPeriod();
      this.saveLoading = false;
      this.isShow = true;
    },
    handlerClose() {
      this.saveLoading = false;
      this.isShow = false;
    },
    // 新建空白模板
    addAcCard() {
      this.addEmptyAcCard();
    },
    addEmptyAcCard() {
      this.dialogVisibleEmpty = true;
      this.closeDialog();
    },
    handleEmptyDialogChange(data) {
      this.dialogVisibleEmpty = false;
      if (data == "cancel") {
        this.isShow = true;
      }
    },
    handleSaveCard(formName) {
      // 只有三级 不做额外处理 向上抛出

      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 暂时不做处理，后端不支持html字符串 
          // this.form.acCardName = this.extractHtmlFromText(this.form.acCardNameNew,this.answerSheet.acCardName)
          this.form.acCardName = this.form.acCardNameNew
          this.$emit("saveCard", this.form);
          this.saveLoading = true;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 是否展示模板遮罩层
    layerHover(i, type) {
      this.mBIndex = type ? i : "no";
    },
    // 切换科目

    closeDialog() {
      this.isShow = false;
      this.$emit("input", false);
    },

    subStrTemplateName(name) {
      return name.length >= 20 ? `${name.substr(0, 20)}...` : name;
    },
  },
};
</script>

<style lang="scss">
.mt20 {
  margin-bottom: 20px;
  .subject-button {
    display: inline-block;
    padding: 10px 20px;
  }
}
.new-card {
  height: 200px;
}
.el-card {
  width: 180px;
  margin-top: 20px;
  position: relative;
  height: 190px;
  .el-card__body {
    padding: 0px;
    height: 100%;
  }
  .img {
    height: 90px;
    text-align: center;
    overflow: hidden;
    img {
      width: auto;
      height: 100%;
      margin: 0 auto;
    }
  }
  .name {
    padding: 8px 0;
    height: 36px;
    text-align: center;
  }
  .tag {
    padding-top: 8px;
    .el-tag {
      margin-right: 5px;
    }
  }
  .score {
    color: #999;
  }
  .card {
    background: #f6f6f6;
    text-align: center;
    height: 100%;
    cursor: pointer;
    color: #bbbbbb;
    i {
      margin-top: 50px;
      margin-bottom: 10px;
      font-size: 50px;
    }
  }
}
.lay {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba($color: #000000, $alpha: 0.2);
  text-align: center;
  line-height: 190px;
}
.operation {
  position: absolute;
  top: 6px;
  right: 8px;
  display: flex;
}

.more {
  height: 40px;
  margin-top: 20px;
  text-align: center;
  color: #00a2d4;
}
.el-popover {
  .title {
    display: flex;
    align-items: center;
  }
  .content {
    margin-left: 28px;
    margin-top: 6px;
    color: #999;
  }
}
</style>
